/* Current Nostalgia — open header dropdowns on hover (desktop, mouse/trackpad only). */
(function () {
  if (window.__cnNavHover) return;
  window.__cnNavHover = true;
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)');

  function setOpen(d, open) {
    if (d.open === open) return;
    d.open = open;
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init() {
    var menus = document.querySelectorAll('.header__inline-menu details');
    menus.forEach(function (d) {
      var li = d.closest('li') || d;
      var timer;
      li.addEventListener('mouseenter', function () {
        if (!canHover || !canHover.matches) return;
        clearTimeout(timer);
        menus.forEach(function (o) { if (o !== d) setOpen(o, false); });
        setOpen(d, true);
      });
      li.addEventListener('mouseleave', function () {
        if (!canHover || !canHover.matches) return;
        timer = setTimeout(function () { setOpen(d, false); }, 150);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
